import Slider from 'react-slick';
import { ImageDetail } from '../types';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

interface ThumbnailSliderProps {
    images: ImageDetail[];
    onThumbnailClick: (index: number) => void;
}

export const ThumbnailSlider: React.FC<ThumbnailSliderProps> = ({
    images,
    onThumbnailClick
}) => {
    const { t } = useTranslation();

    // Calcola dinamicamente slidesToShow in base alla larghezza dello schermo
    const [slidesToShow, setSlidesToShow] = useState(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 576) return 3;
            if (window.innerWidth < 768) return 5;
            if (window.innerWidth < 992) return 6;
            if (window.innerWidth < 1200) return 7;
            return 9;
        }
        return 9;
    });

    // Aggiorna slidesToShow al resize
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 576) {
                setSlidesToShow(3);
            } else if (window.innerWidth < 768) {
                setSlidesToShow(5);
            } else if (window.innerWidth < 992) {
                setSlidesToShow(6);
            } else if (window.innerWidth < 1200) {
                setSlidesToShow(7);
            } else {
                setSlidesToShow(9);
            }   
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const baseSliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToScroll: 1,
        slidesToShow: slidesToShow,
        focusOnSelect: true,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true
    };

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <div className='slider slider-nav limit-height'>
            <Slider
                {...baseSliderSettings}
                afterChange={(current) => onThumbnailClick(current)}
            >
                {images.map((img, index) => (
                    <div key={index} className="slick-slide" style={{ outline: "none" }}>
                        <img
                            className="img-fluid border"
                            alt={`Thumbnail ${index + 1}`}
                            src={img.urlSmall ?? '/assets/images/no_image_small.jpg'}
                            style={{
                                cursor: "pointer",
                                objectFit: "cover"
                            }}
                            onClick={() => onThumbnailClick(index)}
                            loading="lazy"
                            onError={(e) => {
                                e.currentTarget.src = '/assets/images/no_image_small.jpg';
                                e.currentTarget.alt = t('gallery.thumbnailAltFallback', 'Miniatura non disponibile');
                            }}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
};